import React, { useState, useRef, useEffect, useContext, useMemo} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import api from '../services/axios';
import alertService from '../services/alerts';
import '../styles/ProspectosPage.css';
import '../styles/ExportModal.css';  
import { AuthContext } from '../context/AuthContext';  

function ProspectosPage() { 
  const [searchQuery, setSearchQuery] = useState('');
  const [prospectos, setProspectos] = useState([]);
  const alertMostradoRef = useRef(false);
  const [error, setError] = useState('');
  const [estadoProceso, setEstadoProceso] = useState('');
  const [tipoRedSocial, setTipoRedSocial] = useState('');
  const [fechaContactoMin, setFechaContactoMin] = useState('');
  const [fechaContactoMax, setFechaContactoMax] = useState('');
  const [paisOrigen, setPaisOrigen] = useState('');
  const [cursoInteres, setCursoInteres] = useState('');
  const [horarioPreferencia, setHorarioPreferencia] = useState('');
  const [tomoDemostracion, setTomoDemostracion] = useState('');
  const [dia, setDia] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [oldContactCount, setOldContactCount] = useState(0);
  const [isOldContactMode, setIsOldContactMode] = useState(false);
  const filtersPanelRef = useRef(null);
  const overlayRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation(); 
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);

  // 📌 PUNTO B: AGREGAR LA FUNCIÓN handleViewOldContacts AQUÍ
  const handleViewOldContacts = () => {
      // 1. Activa el modo filtro especial
      setIsOldContactMode(true);
      // 2. Limpia el filtro general de búsqueda para evitar conflictos (opcional, pero recomendado)
      setSearchQuery(''); 
      // 3. Limpia los filtros del panel lateral para no confundir al usuario
      cancelFilters(); 
      // 4. Forzar la re-renderización para aplicar el filtro en filteredProspectos
      setSearchTrigger(prev => prev + 1);
  };
  
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1025;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    if (window.innerWidth >= 1025) {
      setSidebarOpen(true);
    }
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location, isMobile]);
  
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleCloseSidebar = () => {
    if (isMobile && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  const horarioOptions = [
    'Matutino',
    'Vespertino',
    'Nocturno',
  ];
  
  const redSocialOptions = [
    'Facebook',
    'Instagram',
    'Messenger',
    'TikTok',
    'Recomendados',
    'WhatsApp',
    'Página Web',
    'X'
  ];

  const estadoProcesoOptions = [
    'no interesado',
    'ignora mensajes',
    'informes',
    'demostracion',
    'examen ubicacion',
    'pendiente de pago',
    'inscrito'
  ];

  const tomoDemostracionOptions = ['Sí', 'No'];

  useEffect(() => {
    fetchProspectos();
    fetchOldContactCount();
  }, [searchTrigger]);

  const fetchProspectos = async () => {
    try {
      console.log('🔄 Iniciando fetchProspectos...');
      const token = localStorage.getItem('token');
      console.log('🔑 Token disponible:', !!token);
      
      const response = await api.get('/prospectos');
      console.log('✅ Respuesta exitosa:', response.status);
      setProspectos(response.data);
      setError('');
    } catch (err) {
      console.error('❌ Error en fetchProspectos:', err);
      console.error('❌ Error response:', err.response);
      setError('Error al obtener la lista de prospectos');
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleEdit = (id) => {
    navigate(`/prospectos/editar/${id}`);
  };

  const handleDelete = async (id) => {
    const confirmed = await alertService.confirm(
      'Eliminar Prospecto',
      '¿Estás seguro de que deseas eliminar este prospecto? Esta acción no se puede deshacer.',
      {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar'
      }
    );

    if (!confirmed.isConfirmed) return;

    try {
      console.log(`🗑️ Iniciando eliminación de prospecto ID: ${id}`);
      
      // Usar timeout más largo para eliminación
      const response = await api.delete(`/prospectos/${id}`, {
        timeout: 30000 // 30 segundos
      });
      
      console.log('✅ Eliminación exitosa:', response.data);
      setProspectos(prospectos.filter((prospecto) => prospecto.id_prospecto !== id));
      setError('');
      await alertService.success(
        'Prospecto Eliminado',
        'El prospecto ha sido eliminado exitosamente.'
      );
    } catch (err) {
      console.error('❌ Error al eliminar prospecto:', err);
      console.error('❌ Error response:', err.response);
      
      let errorMessage = 'Error al eliminar el prospecto';
      
      if (err.code === 'ECONNABORTED') {
        errorMessage = 'La operación tardó demasiado. Inténtalo de nuevo.';
      } else if (err.response && err.response.status === 403) {
        errorMessage = 'No tienes permisos para eliminar prospectos';
      } else if (err.response && err.response.status === 404) {
        errorMessage = 'Prospecto no encontrado';
      } else if (err.response && err.response.status === 409) {
        errorMessage = 'No se puede eliminar el prospecto porque está siendo utilizado en otra tabla';
      } else if (err.response && err.response.status === 500) {
        errorMessage = 'Error interno del servidor. Inténtalo de nuevo.';
      }
      
      await alertService.error('Error', errorMessage);
    }
  };

  //Función para convertir p-a
  const handleConvertToAlumno = async (prospecto) => {
    if (prospecto.estado_proceso !== 'inscrito') {
        await alertService.error(
            'Inscripción Requerida',
            'Solo puedes convertir a alumno a prospectos con el "Estado del proceso" en **inscrito**.'
        );
        return;
    }

    const confirmed = await alertService.confirm(
        'Convertir a Alumno',
        `¿Estás seguro de que quieres convertir al prospecto #${prospecto.id_prospecto} a alumno? Esto es irreversible.`,
        {
            confirmButtonText: 'Convertir',
            cancelButtonText: 'Cancelar'
        }
    );

    if (!confirmed.isConfirmed) return;

    try {
        // Llama al nuevo endpoint que crearemos
        await api.post(`/prospectos/${prospecto.id_prospecto}/convert-to-alumno`, {
            // Datos que el backend podría necesitar o usar por defecto
            fecha_inscripcion: new Date().toISOString().split('T')[0],
            estado_actividad: 'activo',
            curso_actual: prospecto.curso_interes, // Tomar el curso de interés del prospecto
        });
        
        await alertService.success(
            '¡Éxito!',
            `El prospecto #${prospecto.id_prospecto} ha sido convertido a alumno exitosamente.`
        );
        
        // Navegar a la página de alumnos después de la conversión exitosa
        navigate('/alumnos');
        
    } catch (err) {
        console.error('❌ Error al convertir a alumno:', err);
        let errorMessage = 'Error al convertir el prospecto a alumno.';
        
        if (err.response && err.response.data && err.response.data.error) {
            errorMessage = err.response.data.error;
        } else if (err.response && err.response.status === 409) {
            errorMessage = 'Este prospecto ya está registrado como alumno.';
        }
        
        await alertService.error('Error', errorMessage);
    }
};

  // Función para formatear fecha
  const formatDate = (dateString) => {
    if (!dateString) return 'No especificada';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Función para obtener el color del estado
  const getEstadoColor = (estado) => {
    switch (estado) {
      case 'no interesado': //rojo
        return '#EF4444';
      case 'ignora mensajes':
        return '#8B5CF6'; // púrpura
      case 'informes':
        return '#3B82F6'; // azul
      case 'demostracion':
        return '#ec4e93ff';
      case 'examen ubicacion':
        return '#872886ff';
      case 'pendiente de pago':
        return '#F59E0B'; // amarillo
      case 'inscrito':
        return '#10B981'; // verde  
      default:
        return '#6B7280'; // gris
    }
  };

  // Función para obtener el icono de red social
  const getRedSocialIcon = (redSocial) => {
    switch (redSocial) {
      case 'Facebook':
        return 'fab fa-facebook';
      case 'Instagram':
        return 'fab fa-instagram';
      case 'WhatsApp':
        return 'fab fa-whatsapp';
      case 'TikTok':
        return 'fab fa-tiktok';
      case 'LinkedIn':
        return 'fab fa-linkedin';
      case 'X':
        return 'fab fa-x-twitter';
      case 'Página Web':
        return 'fas fa-globe';
      case 'Messenger':
        return 'fab fa-facebook-messenger';
      default:
        return 'fas fa-share-alt';
    }
  };

  const [exportStartDate, setExportStartDate] = useState('');
  const [exportEndDate, setExportEndDate] = useState('');

  const openExportModal = () => {
    setIsModalOpen(true);
    // Establecer fechas por defecto (último mes)
    const today = new Date();
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    setExportStartDate(lastMonth.toISOString().split('T')[0]);
    setExportEndDate(today.toISOString().split('T')[0]);
  };

  const closeExportModal = () => {
    setIsModalOpen(false);
    setExportStartDate('');
    setExportEndDate('');
  };

  const handleExport = async (formato) => {
    try {
      // Validar fechas
      if (!exportStartDate || !exportEndDate) {
        await alertService.error('Error', 'Por favor selecciona las fechas de inicio y fin');
        return;
      }
      
      if (new Date(exportStartDate) > new Date(exportEndDate)) {
        await alertService.error('Error', 'La fecha de inicio no puede ser mayor a la fecha de fin');
        return;
      }

      const response = await api.get('/reportes/reporte', {
        params: {
          tabla: 'prospectos',
          formato: formato,
          fecha_inicio: exportStartDate,
          fecha_fin: exportEndDate
        },
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `reporte_prospectos.${formato === 'excel' ? 'xlsx' : 'pdf'}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      closeExportModal();
      await alertService.success(
        'Exportación Exitosa',
        `El reporte ha sido exportado en formato ${formato.toUpperCase()} exitosamente.`
      );
    } catch (err) {
      let errorMessage = 'Ha ocurrido un error al exportar el reporte. Por favor, inténtalo de nuevo.';
      
      if (err.response && err.response.status === 404) {
        errorMessage = err.response.data.message || 'No hay datos para exportar en el período seleccionado';
      } else if (err.response && err.response.status === 500) {
        errorMessage = 'Error interno del servidor al generar el reporte';
      }
      
      await alertService.error('Error de Exportación', errorMessage);
    }
  };

  const applyFilters = () => {
    setSearchTrigger(prev => prev + 1);
    setFiltersApplied(true);
    setIsFilterOpen(false);
  };

  const cancelFilters = () => {
    setEstadoProceso('');
    setTipoRedSocial('');
    setFechaContactoMin('');
    setFechaContactoMax('');
    setPaisOrigen('');
    setCursoInteres('');
    setHorarioPreferencia('');
    setTomoDemostracion('');
    setDia('');
    setFiltersApplied(false);
    setSearchTrigger(prev => prev + 1);
    setIsFilterOpen(false);
  };

  const areFiltersDefault = () => {
    return !estadoProceso && !tipoRedSocial && !fechaContactoMin && !fechaContactoMax && 
           !paisOrigen && !cursoInteres && !horarioPreferencia && !tomoDemostracion && !dia;
  };

  const getActiveFiltersCount = () => {
    let count = 0;
    if (estadoProceso) count++;
    if (tipoRedSocial) count++;
    if (fechaContactoMin) count++;
    if (fechaContactoMax) count++;
    if (paisOrigen) count++;
    if (cursoInteres) count++;
    if (horarioPreferencia) count++;
    if (tomoDemostracion) count++;
    if (dia) count++;
    return count;
  };

  const handleClosePanel = () => {
    setIsFilterOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) {
      setIsFilterOpen(false);
    }
  };

  const { user } = useContext(AuthContext); 
  const allowedRolesForActions = ['administrador', 'moderador']; 

// ---- Helpers para fechas y regla de 4 meses ----
function safeToDate(value) {
  if (!value) return null;
  // Para garantizar que la comparación sea solo por día (como en SQL DATE_SUB),
  // se puede crear la fecha en UTC para evitar problemas de zona horaria del navegador.
  const d = new Date(value);
  // Si la fecha en la BD es solo 'YYYY-MM-DD', new Date() la interpreta como medianoche UTC.
  // Si tiene hora, usa la hora.
  return Number.isNaN(d.getTime()) ? null : d;
}

// 4 meses calendario
const fourMonthsAgo = useMemo(() => {
  const ref = new Date();
  ref.setMonth(ref.getMonth() - 4);
  // Para ser lo más cercano posible a la lógica de la BD:
  // Si usas fechas en formato "YYYY-MM-DD", puedes establecer la hora a 00:00:00 para comparar solo el día.
  ref.setHours(0,0,0,0);
  return ref;
}, []);
  // Usa fecha_ultimo_contacto como fuente de verdad; si no existe, cae a fecha_contacto

function debePintarVerde(prospecto) {
  // 1. Excluir estados que no necesitan seguimiento
  const excludedStatuses = ['inscrito', 'eliminado'];
  if (excludedStatuses.includes(prospecto.estado_proceso)) {
      return false;
  }
  
  // 2. Comprobar la antigüedad de la fecha
  const fecha = prospecto.ultimo_contacto ?? prospecto.fecha_contacto;
  const d = safeToDate(fecha);
  if (!d) return false;
  
  // Usar d < fourMonthsAgo para asegurar que la fecha sea estrictamente anterior (más antigua)
  return d < fourMonthsAgo; 
}

useEffect (()=>{
    if (prospectos.length> 0 && !alertMostradoRef.current){
      const prospectosSinSeguimiento = prospectos.filter(debePintarVerde);
      if (prospectosSinSeguimiento.length > 0){
        const listaHtml = `
          <p>Los siguientes prospectos requieren atención inmediata:</p>
          <ul style="text-align: left; list-style-position: inside;">
            ${prospectosSinSeguimiento.map(p => 
            `<li><b>ID: ${p.id_prospecto}</b> - Tel: ${p.numero_telefonico || 'N/A'}</li>`
            ).join('')}
          </ul>`;
        const alertConfig = {
          icon: 'warning',
          title: `${prospectosSinSeguimiento.length} Prospectos sin Seguimiento`,
          html: listaHtml,
        }
        alertService.fire(alertConfig)
        // Marcamos la alerta como mostrada para que no vuelva a salir
        alertMostradoRef.current = true;
      }
    }
  }, [prospectos]);

  const filteredProspectos = prospectos.filter(prospecto => {
    // 🎯 LÓGICA DEL MODO "CONTACTO VIEJO"
    if (isOldContactMode) {
        // Solo incluye el prospecto si debePintarVerde (contacto >= 4 meses) es TRUE.
        return debePintarVerde(prospecto); 
    }
    const matchesSearch = searchQuery === '' || 
      prospecto.numero_telefonico?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      prospecto.curso_interes?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      prospecto.estado_proceso?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      prospecto.tipo_red_social?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      prospecto.observaciones?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesFilters = areFiltersDefault() || (
      (!estadoProceso || prospecto.estado_proceso === estadoProceso) &&
      (!tipoRedSocial || prospecto.tipo_red_social === tipoRedSocial) &&
      (!fechaContactoMin || prospecto.fecha_contacto >= fechaContactoMin) &&
      (!fechaContactoMax || prospecto.fecha_contacto <= fechaContactoMax) &&
      (!paisOrigen || prospecto.pais_origen?.toLowerCase().includes(paisOrigen.toLowerCase())) &&
      (!cursoInteres || prospecto.curso_interes?.toLowerCase().includes(cursoInteres.toLowerCase())) &&
      (!horarioPreferencia || prospecto.horario_preferencia === horarioPreferencia) &&
      (!tomoDemostracion || prospecto.tomo_demostracion === tomoDemostracion) &&
      (!dia || prospecto.dia?.toLowerCase().includes(dia.toLowerCase()))
    );

    return matchesSearch && matchesFilters;
  });

  // 🔹 Aquí agregamos el ordenamiento
  prospectos.sort((a, b) => {
    const numA = parseInt(a.numero_prospectos || 0, 10);
    const numB = parseInt(b.numero_prospectos || 0, 10);
    return numA - numB;
  });

  const totalCount = prospectos.length;
  const filteredCount = filteredProspectos.length;
  const isFiltered = !areFiltersDefault() || (searchQuery && searchQuery.trim() !== '');

  // Función para obtener la cuenta de prospectos con contacto viejo
  const fetchOldContactCount = async () => {
    try {
      const response = await api.get('/prospectos/viejos-contactos'); //
        setOldContactCount(response.data.length); //
      } catch (err) {
        console.error('❌ Error al obtener el contador de viejos contactos:', err);
        // Manejar error silenciosamente o mostrar un error si es crítico
      }
  }; 

  return (
    <div className="dashboard-container">
      {(!isMobile || (isMobile && sidebarOpen)) && (
        <Sidebar 
          onLogoClick={() => { if (isMobile) setSidebarOpen(false); }}
          onLinkClick={handleCloseSidebar}
        />
      )}
      <div className={`main-content${isFilterOpen ? ' panel-open' : ''}`} onClick={handleCloseSidebar}>
        <div className="dashboard-title-card">
          {isMobile && (
            <button 
              className="menu-toggle"
              onClick={toggleSidebar}
              aria-label="Abrir menú"
            >
              <i className="fas fa-bars"></i>
            </button>
          )}
          <div className="dashboard-title-section">
            <h1 className="dashboard-title">Prospectos</h1>
            <span className="dashboard-title-sub">Gestión de prospectos</span>
          </div>
        </div>
        {error && <p>{error}</p>}
        <div className="search-filter-container">
          <input
            type="text"
            placeholder="Buscar por teléfono, curso, estado u observaciones..."
            value={searchQuery}
            onChange={handleSearch}
            className="search-input"
          />

         {/* <div className="filters-button-wrap">
            <button
             className={`filter-button ${!areFiltersDefault() ? 'active-filters' : ''}`}
             onClick={() => setIsFilterOpen(!isFilterOpen)}
             title="Abrir filtros"
            >
              <i className="fa-solid fa-sliders"></i>
              <span className="filter-button-text"> Filtros</span> 
            </button>
            {getActiveFiltersCount() > 0 && (
              <span className="filter-badge">{getActiveFiltersCount()}</span>
            )}
          </div>*/}

          {/* 🔔 CONTADOR DE CONTACTOS VIEJOS (MODIFICADO) */}
          {oldContactCount > 0 && (
              <div 
                  className="old-contact-alert" 
                  title="Click para ver prospectos con más de 4 meses sin contacto"
                  onClick={handleViewOldContacts} 
              >
                  <i className="fas fa-bell"></i>
                  <span className="count-badge">{oldContactCount}</span>
                  <span className="alert-text"> Contactos Viejos</span>
              </div>
          )}
          {/* FIN CONTADOR */}

          {/* ❌ BOTÓN PARA SALIR DEL MODO ESPECIAL */}
          {isOldContactMode && (
              <button
                  className="clear-old-contact-mode-btn"
                  onClick={() => {
                      setIsOldContactMode(false);
                      setSearchTrigger(prev => prev + 1); // Forzar recarga para mostrar todos
                  }}
                  title="Mostrar todos los prospectos"
              >
                  <i className="fas fa-times"></i> Salir del filtro de antigüedad
              </button>
          )}
          {/* FIN BOTÓN SALIR */}

          <div className='results-summary'>
            <i className="fas fa-users"></i>
            <span>
              {isOldContactMode ? ( // 👈 NUEVA LÓGICA DE RESUMEN
                <> {filteredCount} prospectos **antiguos** </>
              ) : isFiltered ? (
                <> {filteredCount} de {totalCount} prospectos </>
              ) : (
                <> {totalCount} prospectos en total </>
              )}
            </span>
          </div>
          
          <button
            className={`filter-button ${!areFiltersDefault() ? 'active-filters' : ''}`}
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            title="Abrir filtros"
          >
            <i className="fa-solid fa-sliders"></i>
            <span className="filter-button-text">
              Filtros
              {!areFiltersDefault() && <span className="filter-count">({getActiveFiltersCount()})</span>}
            </span>
            {!areFiltersDefault() && <span className="filter-indicator"></span>}
          </button>
        </div>

        {isFilterOpen && (
          <div
            className="filters-overlay"
            ref={overlayRef}
            onClick={handleOverlayClick}
          ></div>
        )}

        {isFilterOpen && (
          <div className="filters-panel" ref={filtersPanelRef}>
            <button className="close-button" onClick={handleClosePanel}>
              ×
            </button>
            <h2>Filtros</h2>

            <div className="filter-group">
              <label>Estado del Proceso</label>
              <select
                value={estadoProceso}
                onChange={(e) => setEstadoProceso(e.target.value)}
                className="filter-input"
              >
                <option value="">Todos</option>
                {estadoProcesoOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Tipo de Red Social</label>
              <select
                value={tipoRedSocial}
                onChange={(e) => setTipoRedSocial(e.target.value)}
                className="filter-input"
              >
                <option value="">Todos</option>
                {redSocialOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Fecha de Contacto (Desde)</label>
              <input
                type="date"
                value={fechaContactoMin}
                onChange={(e) => setFechaContactoMin(e.target.value)}
                className="filter-input"
              />
            </div>

            <div className="filter-group">
              <label>Fecha de Contacto (Hasta)</label>
              <input
                type="date"
                value={fechaContactoMax}
                onChange={(e) => setFechaContactoMax(e.target.value)}
                className="filter-input"
              />
            </div>

            <div className="filter-group">
              <label>País de Origen</label>
              <input
                type="text"
                value={paisOrigen}
                onChange={(e) => setPaisOrigen(e.target.value)}
                className="filter-input"
                placeholder="Ej. México"
              />
            </div>

            <div className="filter-group">
              <label>Curso de Interés</label>
              <input
                type="text"
                value={cursoInteres}
                onChange={(e) => setCursoInteres(e.target.value)}
                className="filter-input"
                placeholder="Ej. Programación"
              />
            </div>

            <div className="filter-group">
              <label>Horario de Preferencia</label>
              <select
                value={horarioPreferencia}
                onChange={(e) => setHorarioPreferencia(e.target.value)}
                className="filter-input"
              >
                <option value="">Todos</option>
                {horarioOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Tomó Demostración</label>
              <select
                value={tomoDemostracion}
                onChange={(e) => setTomoDemostracion(e.target.value)}
                className="filter-input"
              >
                <option value="">Todos</option>
                {tomoDemostracionOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Día</label>
              <input
                type="text"
                value={dia}
                onChange={(e) => setDia(e.target.value)}
                className="filter-input"
                placeholder="Ej. Lunes"
              />
            </div>

            <div className="filter-buttons">
              <button onClick={applyFilters} className="apply-button">
                <i className="fas fa-check"></i>
                Aplicar Filtros
              </button>
              <button onClick={cancelFilters} className="cancel-button">
                <i className="fas fa-times"></i>
                Limpiar Filtros
              </button>
            </div>
          </div>
        )}

        <div className="actions-container">
          <button className="add-button" onClick={() => navigate('/prospectos/agregar')}>
            <i className="fas fa-plus"></i>
            Agregar Prospecto
          </button>
          <button className="export-button" onClick={openExportModal}>
            <i className="fas fa-download"></i>
            Exportar
          </button>
        </div>

        {error && (
          <div className="error-message" style={{ 
            backgroundColor: '#FEE2E2', 
            color: '#DC2626', 
            padding: '1rem', 
            borderRadius: '8px', 
            marginBottom: '1rem',
            border: '1px solid #FCA5A5'
          }}>
            {error}
          </div>
        )}

        <div className="prospectos-grid">
          {filteredProspectos.length > 0 ? (
            filteredProspectos.map((prospecto) => (
              <div key={prospecto.id_prospecto} className="prospecto-card">
                {/* Cambio de color dependiendo del último contacto */}
                <div
                  className="barra-contacto"
                  style ={{
                      height: "5px",
                      width: "100%",
                      borderRadius: "4px",
                      marginBottom: "8px",
                      backgroundColor: debePintarVerde(prospecto) ? "green" : "#1E90FF", 
                  }}
                />
                <div className="card-header">
                  <div className="prospecto-id">
                    <span className="id-label">ID:</span>
                    <span className="id-value">{prospecto.id_prospecto}</span>
                  </div>
                  <div className="prospecto-numero">
                    <span className="id-label">Prospecto: #  </span>
                    <span className="id-value">{prospecto.numero_prospectos ?? 'No especificado'}</span>
                  </div>
                  <div className="card-actions">
                    {allowedRolesForActions.includes(user?.rol) && (
                      <>
                        <button
                          className="action-btn convert-btn" 
                          onClick={() => handleConvertToAlumno(prospecto)}
                          title="Convertir a Alumno"
                          // Deshabilitar si no está 'inscrito'
                          disabled={prospecto.estado_proceso !== 'inscrito'} 
                        >
                          <i className="fas fa-user-graduate"></i>
                        </button>
                        <button
                          className="action-btn edit-btn"
                          onClick={() => handleEdit(prospecto.id_prospecto)}
                          title="Editar prospecto"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="action-btn delete-btn"
                          onClick={() => handleDelete(prospecto.id_prospecto)}
                          title="Eliminar prospecto"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </>
                    )}
                  </div>
                </div>

                <div className="card-content">
                  <div className="info-section">
                    <div className="info-item">
                      <span className="info-label">
                        <i className="fas fa-phone"></i> Teléfono:
                      </span>
                      <span className="info-value">{prospecto.numero_telefonico || 'No especificado'}</span>
                    </div>

                    <div className="info-item">
                      <span className="info-label">
                        <i className="fas fa-calendar"></i> Fecha de contacto:
                      </span>
                      <span className="info-value">{formatDate(prospecto.fecha_contacto)}</span>
                    </div>

                    <div className="info-item">
                      <span className="info-label"> Ultimo Contacto 
                        <i className="fas fa-calendar"></i>
                      </span>
                      <span className="info-value">{formatDate(prospecto.ultimo_contacto)}</span>
                    </div>
                    
                    <div className="info-item">
                      <span className="info-label">
                        <i className={getRedSocialIcon(prospecto.tipo_red_social)}></i> Red social:
                      </span>
                      <span className="info-value">{prospecto.tipo_red_social}</span>
                    </div>

                    <div className="info-item">
                      <span className="info-label">
                        <i className="fas fa-graduation-cap"></i> Curso de interés:
                      </span>
                      <span className="info-value">{prospecto.curso_interes || 'No especificado'}</span>
                    </div>

                    <div className="info-item">
                      <span className="info-label">
                        <i className="fas fa-clock"></i> Horario preferido:
                      </span>
                      <span className="info-value">{prospecto.horario_preferencia}</span>
                    </div>

                    <div className="info-item">
                      <span className="info-label">
                        <i className="fas fa-calendar-day"></i> Día:
                      </span>
                      <span className="info-value">{prospecto.dia || 'No especificado'}</span>
                    </div>

                    <div className="info-item">
                      <span className="info-label">
                        <i className="fas fa-map-marker-alt"></i> País:
                      </span>
                      <span className="info-value">{prospecto.pais_origen}</span>
                    </div>

                    {prospecto.estado && (
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-map"></i> Estado:
                        </span>
                        <span className="info-value">{prospecto.estado}</span>
                      </div>
                    )}

                    {prospecto.observaciones && (
                      <div className="info-item">
                        <span className="info-label">
                          <i className="fas fa-sticky-note"></i> Observaciones:
                        </span>
                        <span className="info-value">{prospecto.observaciones}</span>
                      </div>
                    )}
                  </div>

                  <div className="status-section">
                    <div className="estado-container">
                      <span className="estado-label">Estado del proceso:</span>
                      <span 
                        className="estado-badge" 
                        style={{ backgroundColor: getEstadoColor(prospecto.estado_proceso) }}
                      >
                        {prospecto.estado_proceso}
                      </span>
                    </div>

                    <div className="demo-container">
                      <span className="demo-label">Tomó demostración:</span>
                      <span className={`demo-badge ${prospecto.tomo_demostracion === 'Sí' ? 'demo-yes' : 'demo-no'}`}>
                        {prospecto.tomo_demostracion}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <div className="empty-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>No hay prospectos para mostrar</h3>
              <p>No se encontraron prospectos que coincidan con los criterios de búsqueda.</p>
              <button 
                className="add-button" 
                onClick={() => navigate('/prospectos/agregar')}
                style={{ marginTop: '1rem' }}
              >
                <i className="fas fa-plus"></i>
                Agregar primer prospecto
              </button>
            </div>
          )}
        </div>

        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal">
              <h2>Exportar Reporte de Prospectos</h2>
              
              <div className="export-filters">
                <div className="filter-group">
                  <label>Fecha de Inicio:</label>
                  <input
                    type="date"
                    value={exportStartDate}
                    onChange={(e) => setExportStartDate(e.target.value)}
                    className="filter-input"
                  />
                </div>
                
                <div className="filter-group">
                  <label>Fecha de Fin:</label>
                  <input
                    type="date"
                    value={exportEndDate}
                    onChange={(e) => setExportEndDate(e.target.value)}
                    className="filter-input"
                  />
                </div>
              </div>
              
              <div className="export-buttons">
                <button onClick={() => handleExport('excel')} className="export-btn excel">
                  <i className="fas fa-file-excel"></i>
                  Exportar a Excel
                </button>
                <button onClick={() => handleExport('pdf')} className="export-btn pdf">
                  <i className="fas fa-file-pdf"></i>
                  Exportar a PDF
                </button>
              </div>
              
              <button className="close-modal" onClick={closeExportModal}>
                Cancelar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProspectosPage;
